import { Button, Stack } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { GenericInput } from '../../components/inputs/GenericInput'
import { openPopup } from '../../stateManagement/actions/popupActions'
import { getRecipientList, saveRecipientList, saveRecipientListSchema } from '../../services/integrationService'
import { RecipientListType } from '../../types/types'


type payloadItemsType = {
  type: string,
  displayName: string,
  description: string
}

const payloadItems: payloadItemsType[] = [
  {
    type: "to",
    displayName: "To receipients",
    description: "To receipients of the email",
  },
  {
    type: "cc",
    displayName: "Cc receipients",
    description: "Cc receipients of the email",
  },
  {
    type: "bcc",
    displayName: "Bcc receipients",
    description: "Bcc receipients of the email",
  }
]

type responseType = {
  data: any
  status: number
}

const defaultRecipientList: RecipientListType = {
  to: "",
  cc: "",
  bcc: "",
}

export default function RecipientList() {

  const schemaName = 'RecipientList';

  const [features, setFeatures] = useState<RecipientListType>(defaultRecipientList);

  const fetchRecipientList = useCallback((retry: boolean) => {
    getRecipientList(schemaName).then((response: responseType) => {
      if (response.status === 200 || response.status === 201) {
        setFeatures(response.data.features[0] || defaultRecipientList)
      }
    }, (e: any) => {
      console.error('unable to fetch recipient list : ', e)
      if (retry)
        saveSchema();
    })
  }, [])

  const saveSchema = useCallback(() => {
    const schema = {
      "spec": {}
    }
    saveRecipientListSchema(schemaName,schema).then((response: responseType) => {
      if (response.status === 200 || response.status === 201) {
        fetchRecipientList(false);
      }
    })
  }, []);

  function enrichBody(body: RecipientListType) {
    body.to = body.to.replace(/\s/g, "");
    body.cc = body.cc.replace(/\s/g, "");
    body.bcc = body.bcc.replace(/\s/g, "");
    return body;
  }

  function ValidateEmails(email: string) {
    let mailformat = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!mailformat.test(email)) {
      openPopup('Error', "Invalid email address! " + email);
      return false;
    } else return true;
  }

  function ValidateForm(body: RecipientListType) {
    let flag = true;
    if (body.to && body.to.length > 0) {
      body.to.split(",").forEach((email: string) => {
        if (!ValidateEmails(email)) { flag = false; }
      });
    } else {
      openPopup('Error', "Please enter atleast one recipient in To receipients");
      return false;
    };
    if (flag && body.cc && body.cc.length > 0) {
      body.cc.split(",").forEach((email: string) => {
        if (!ValidateEmails(email)) { flag = false; }
      });
    }
    if (flag && body.bcc && body.bcc.length > 0) {
      body.bcc.split(",").forEach((email: string) => {
        if (!ValidateEmails(email)) { flag = false; }
      });
    }
    return flag;
  }

  const saveFunction = () => {
    const id = features.id || schemaName;
    let body = {...defaultRecipientList};
    body.to = features.to || "";
    body.cc = features.cc || "";
    body.bcc = features.bcc || "";
    if (features.message && features.message.length > 0) body['message'] = features.message;
    if (features.subject && features.subject.length > 0) body['subject'] = features.subject;
    body = enrichBody(body)
    if (!ValidateForm(body)) {
      return;
    }
    saveRecipientList(schemaName,id,body)
      .then(() => openPopup("Success", "Saved Succesfully !"))
      .catch((e:any) => { openPopup("Error", "Error Occured while saving"); console.error(e) })
  }

  useEffect(() => {
    fetchRecipientList(true);
  }, [fetchRecipientList]);


  return (
    <Stack margin={4} spacing={5}>
      <h3 style={{marginBottom:"30px"}} className="integration-dashboard-heading">Integration Recipient List</h3>
      {payloadItems.map((item: payloadItemsType, idx: number) =>
        <GenericInput
          key={idx}
          textFieldInputProps={{
            fullWidth: true,
            label: item.displayName,
            placeholder: item.description,
            value: Object(features)[item.type] || "",
            onChange: (e) => setFeatures({ ...features, [item.type]: e.target.value })
          }}
        />)
      }
      <Stack flexDirection={'row'} justifyContent={'space-between'} maxWidth={"230px"}>
        <Button className="navigation-btn" style={{width:"100px",}} onClick={() => { saveFunction() }}>Save</Button>
      </Stack>
    </Stack>

  )
}

